// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SecondMenu-module--wrap--18BuZ","navItem":"SecondMenu-module--navItem--1l0q3"};